<template>
  <div class="today-course">
    <div class="course">
      <div class="quanbukechena">
        <div v-for="item in courseList" :key="item.id" class="one">
          <div class="img-box">
            <img class="tuimg" :src="item.coverpic" />
          </div>
          <div class="info">
            <p class="title">{{ item.name }}</p>
            <p class="sub-title">{{ liveTypeToText(item.live_type) }}</p>
            <p class="time">开课：{{ item.start_time }}</p>
            <div class="bottom-row">
              <span class="status-text" v-if="item.status === 1">未开播</span>
              <span class="status-text" v-if="item.status === 2">正在直播</span>
              <span class="status-text" v-if="item.status === 3">直播结束</span>
              <div class="btn" @click="enterLive(item)">进入直播</div>
            </div>
          </div>
        </div>
        <div v-if="!courseList.length" class="empty">
          暂无今日课程
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
import { useOrgConfig } from '@/utils/useUserConfig.js'

export default {
  name: "TodayCourseLive",
  data() {
    return {
      courseList: [],
      insertmoblie: 0
    };
  },
  created() {
    if (this.$route.query.insertmoblie) {
      this.insertmoblie = this.$route.query.insertmoblie
    }
    this.fetchTodayCourses();
  },
  computed: {
    ...mapGetters({
      fans_id: 'user/getFansId'
    }),
    liveTypeToText() {
      return (liveType) => {
        // 1直播 2智能录播 3独立录播  4.互动小班课
        switch (liveType) {
          case 1:
            return '直播';
          case 2:
            return '智能录播';
          case 3:
            return '独立录播';
          case 4:
            return '互动小班课';
          default:
            return '';
        }
      };
    },
  },
  methods: {
    getSystemDate() {
        const currentDate = new Date()
        const year = currentDate.getFullYear()
        const month = currentDate.getMonth() + 1
        const day = currentDate.getDate()
        return `${year}-${month>9?month:'0'+month}-${day>9?day:'0'+day}`
    },
    fetchTodayCourses() {
      const currentDay = this.getSystemDate()
      const data = {
        page: 1,
        num: 10000,
        date: currentDay, // 今日课程
        status: '' // 1 未上过课 2 正在上课 3 已上完课
      };
      this.$api.post("https://preview_online.shkt.online/onlineapi/stu/course/dayChapters", data).then((res) => {
        if (res.data && res.data.code === 200) {
          this.courseList = res.data.data.list || [];
        }
      });
    },
    enterLive(item) {
      const data = {
        course_id: item.course_id,
        class_id: item.class_id,
        chapter_id: item.id,
      };
      this.$api.post('/stu/course/liveAuth', data).then((res) => {
        if (res.data.code === 200) {
          if (item.type == 4) {
            this.fakeLiveJump(item, res.data);
          } else {
            this.liveAddress(item, res.data);
          }
        } else {
           Toast.fail(res.data.message);
        }
      });
    },
    async fakeLiveJump(item1, item) {
        const { live_domain } = await useOrgConfig()
        const liveUrl = `${live_domain}/f/?ds_id=${item1.ds_id}&tid=${item1.room_id}&token=${item.data.liveToken}&other=1&shool_token=${localStorage.getItem('token')}`
        if (this.insertmoblie == 1 && window.androids && window.androids.goNativeFakeChatroom) {
            // eslint-disable-next-line no-undef
            window.androids.goNativeFakeChatroom(liveUrl);
        } else if (this.insertmoblie == 1 && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.goNativeFakeChatroom) {
            window.webkit.messageHandlers.goNativeFakeChatroom.postMessage(liveUrl)
        } else {
            location.href = liveUrl
        } 
    },
    async liveAddress(item1, item) {
        const { live_domain } = await useOrgConfig();
        // 查询直播地址
        if (item1.play_style == 4) {
            if (window.androids && window.androids.goInteractionChatroom) { // 安卓
                // eslint-disable-next-line no-undef
                this.$api.post('/stu/course/getinterid', { ds_id: item1.ds_id }).then((res1) => {
                    if (res1.data.code === 200) {
                        // eslint-disable-next-line no-undef
                        window.androids.goInteractionChatroom(res1.data.data,localStorage.getItem('token'))
                    }
                })
            } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.goInteractionChatroom) {// ios
            // eslint-disable-next-line no-undef
                window.webkit.messageHandlers.goInteractionChatroom.postMessage(`${res1.data.data}|${localStorage.getItem('token')}`)
            }else {
                location.href = `${live_domain}/tcicMiddlePage/#/h5?ds_id=${item1.ds_id}&classid=${item1.interact_id}&fans_id=${this.fans_id}`;
            }
        } else {
            const liveUrl = `${live_domain}/?ds_id=${item1.ds_id}&token=${item.data.liveToken}&other=1&shool_token=${localStorage.getItem('token')}`
            if (this.insertmoblie == 1 && window.androids && window.androids.goNativeChatroom) {
                window.androids.goNativeChatroom(liveUrl)
            } else if (this.insertmoblie == 1 && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.goNativeChatroom) {
                // eslint-disable-next-line no-undef
                window.webkit.messageHandlers.goNativeChatroom.postMessage(liveUrl)
            } else {
                location.href = liveUrl
            }      
        }
    }
  },
};
</script>

<style scoped>
.today-course {
  width: 100%;
  background: #f5f5f5;
}

.course {
  margin: 0.27rem;
}

.quanbukechena {
  background-color: #ffffff;
  border-radius: 0.32rem;
  padding: 0.32rem 0.24rem;
}

.one {
  display: flex;
  margin-bottom: 0.32rem;
}

.one:last-child {
  margin-bottom: 0;
}

.img-box {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 0.24rem;
  overflow: hidden;
  flex-shrink: 0;
}

.tuimg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.info {
  flex: 1;
  margin-left: 0.32rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.title {
  font-size: 0.43rem;
  font-weight: 600;
  color: #101010;
  line-height: 1.4;
  margin-bottom: 0.12rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.sub-title {
  font-size: 0.32rem;
  color: #888888;
  margin-bottom: 0.04rem;
}

.time {
  font-size: 0.32rem;
  color: #888888;
  margin-bottom: 0.16rem;
}

.bottom-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.status-text {
  font-size: 0.32rem;
  color: #ff8500;
}

.btn {
  width: 1.92rem;
  height: 0.64rem;
  border-radius: 0.32rem;
  border: 1px solid #1872ed;
  text-align: center;
  line-height: 0.64rem;
}

.btn a {
  font-size: 0.32rem;
  color: #1872ed;
}

.empty {
  text-align: center;
  padding: 0.8rem 0;
  font-size: 0.36rem;
  color: #888888;
}
</style>